const cartDrawer = document.querySelector('cart-drawer');

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

function activeCartItems(){
  const cartDrawer = document.querySelector('cart-drawer');
  cartDrawer.classList.remove('is-empty');
}

function openCartDrawer(){
  cartDrawer.classList.add('active');
}

function closeCartDrawer(){
  cartDrawer.classList.remove('active');
}

async function updateCartUI(){
    data['items'] = [];
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();
  
    const html = new DOMParser().parseFromString(text, 'text/html')
  
    const newBox = html.querySelector(".drawer").innerHTML;
    document.querySelector(".drawer").innerHTML = newBox;
}

async function addToCart(data) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const cart = await response.json();

        await updateCartUI();

    } catch (error) {
        console.error("Impossible d'ajouter le produit au panier", error);
    }
}